export const INITIAL_STATE = {
  title: "Our Mission",
  desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
};

export const formReducer = (state, action) => {
  switch (action.type) {
    case "CHANGE_TEXT":
      return {
        ...state,
        title: action.title,
        desc: action.desc,
      };
    default:
      return state;
  }
};
